var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMokaiVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 654.83 712.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 512.08,
    y1: 912.56,
    x2: 512.08,
    y2: 11.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#057fc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0b7cbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1e74b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3c67af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6555a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9b3e8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#db227a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61d76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 327.41,
    y1: 912.56,
    x2: 327.41,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 142.75,
    y1: 912.56,
    x2: 142.75,
    y2: 11.55,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 165.65,
    y1: 97.91,
    x2: 165.65,
    y2: -10.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 86.7,
    y1: 738.67,
    x2: 86.7,
    y2: 848.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 258.23,
    y1: 738.67,
    x2: 258.23,
    y2: 848.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 413.61,
    y1: 738.67,
    x2: 413.61,
    y2: 848.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 550.63,
    y1: 738.67,
    x2: 550.63,
    y2: 848.87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 646.67,
    y1: 738.67,
    x2: 646.67,
    y2: 848.87,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m647.03,319.61c0,85.57-33.62,163.27-88.37,220.64-7.72,8.09-19.57,10.74-30.01,6.71-121.27-46.82-152.04-84.89-151.51-113.88.9-49.13,91.52-64.05,132.34-150.96,21.92-46.67,21.59-98.4,10.01-149.32-6.35-27.93,28.58-46.16,47.55-24.7,49.78,56.35,79.99,130.4,79.99,211.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m474.8,68.77l-123.45,213.82c-10.64,18.43-37.24,18.43-47.88,0l-123.45-213.82c-8.08-13.99-2.53-31.97,12.11-38.81C233.21,10.74,279.06,0,327.41,0c48.36,0,94.2,10.74,135.29,29.96,14.63,6.85,20.18,24.82,12.1,38.81Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m126.18,546.96c-10.44,4.03-22.29,1.39-30.01-6.71C41.42,482.87,7.8,405.17,7.8,319.61c0-81.09,30.2-155.13,79.98-211.49,18.96-21.47,53.89-3.23,47.55,24.69-11.57,50.92-11.89,102.64,10.03,149.31,40.82,86.9,131.44,101.82,132.34,150.96.53,28.99-30.24,67.06-151.51,113.88Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 165.66,
    y1: 43.9,
    x2: 165.64,
    y2: 43.91
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m139.91,618.61l-44.88,89.25c-1.7,3.23-4.93,4.76-8.33,4.76s-6.63-1.53-8.16-4.76l-44.88-89.25-19.38,88.57c-.85,3.74-3.74,5.27-6.63,5.27-3.91,0-7.65-2.55-7.65-6.97,0-.51,0-1.02.17-1.53l23.29-105.74c.85-3.91,4.08-5.95,7.14-5.95s6.12,2.21,7.99,5.78l48.11,95.37,48.11-95.37c1.87-3.57,4.93-5.95,7.99-5.95,3.23,0,6.29,2.04,7.14,6.12l23.29,105.57c0,.68.17,1.19.17,1.7,0,4.42-3.74,6.97-7.65,6.97-2.89,0-5.78-1.53-6.46-5.27l-19.38-88.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m258.06,712.62c-41.48,0-69.53-25.67-69.53-61.03s28.05-60.86,69.53-60.86,69.87,25.67,69.87,60.86-28.39,61.03-69.87,61.03Zm0-109.48c-30.6,0-52.53,19.72-52.53,48.45s21.93,48.45,52.53,48.45,52.7-19.55,52.7-48.45-22.1-48.45-52.7-48.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m369.41,655.16l83.98-61.37c1.53-1.02,3.06-1.7,4.76-1.7,3.4,0,6.46,2.72,6.46,6.63,0,2.38-1.36,4.08-3.91,5.95l-51.68,37.91,62.39,56.27c1.7,1.53,2.72,3.4,2.72,5.61,0,4.42-3.91,8.16-7.82,8.16-1.87,0-3.57-.85-5.27-2.21l-64.77-58.48-26.86,19.72v32.81c0,5.27-4.25,8.16-8.33,8.16s-7.99-2.89-7.99-8.16v-104.55c0-4.93,4.08-7.82,8.16-7.82s8.16,2.89,8.16,7.82v55.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m592.11,682.53h-83.13l-15.64,26.69c-1.36,2.38-3.91,3.4-6.12,3.4-3.91,0-7.65-3.06-7.65-7.48,0-1.36.34-2.55,1.02-3.74l62.22-105.57c1.7-2.72,4.08-4.25,7.82-4.25s6.12,1.53,7.82,4.25l62.22,105.57c.68,1.19,1.02,2.38,1.02,3.74,0,4.42-3.91,7.48-7.65,7.48-2.38,0-4.76-1.02-6.12-3.4l-15.81-26.69Zm-41.48-70.55l-34.51,58.48h68.85l-34.34-58.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m638.51,599.91c0-4.93,3.91-7.82,8.16-7.82s8.16,2.89,8.16,7.82v104.55c0,5.27-3.74,8.16-8.33,8.16-4.08,0-7.99-2.89-7.99-8.16v-104.55Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMokaiVertical);
export default __webpack_public_path__ + "static/media/mokai-vertical.0bb6116c432b2b24dfeb25fe2f0c1d69.svg";
export { ForwardRef as ReactComponent };